import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ContactUs, TawkChat } from "@/components";
import "./AboutUs.css";

const AboutUsScreen: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="v2-body">
      <TawkChat />

      <div className="v2-hero">
        <img
          src={process.env.REACT_APP_URL_ABOUT_US_BANNER}
          className="v2-hero-bg"
          alt="Mimo Cupido Casal"
          loading="eager"
        />
        <div className="v2-container">
          <div className="v2-hero-content">
            <h1>
              Sobre o Mimo Cupido <br />
              <span className="v2-gold-text">
                Relacionamento de Alto Padrão
              </span>
            </h1>
          </div>
        </div>
      </div>

      <section className="v2-section">
        <p>
          O Mimo Cupido é uma plataforma de relacionamento de alto padrão criada
          para conectar pessoas que valorizam discrição, segurança e conexões
          reais.
        </p>
        <p>
          Mais do que um aplicativo de encontros, somos uma experiência de
          matchmaking premium baseada em compatibilidade, respeito e intenção
          verdadeira.
        </p>
      </section>

      <section className="v2-section">
        <h2>Nossa história</h2>

        <p>
          O Mimo Cupido nasceu para modernizar a forma como pessoas se conectam
          em relacionamentos de alto padrão no Brasil.
        </p>

        <p>
          Observamos que muitas plataformas de namoro não ofereciam segurança,
          curadoria e experiência de qualidade para usuários que buscam algo
          mais sério e alinhado.
        </p>

        <p>
          Por isso, criamos uma solução focada em tecnologia, privacidade e
          conexões reais entre pessoas com objetivos compatíveis.
        </p>
      </section>

      <section className="v2-section mission-section">
        <div className="mission-card">
          <h3>Missão</h3>

          <p>
            Conectar pessoas através de um matchmaking premium baseado em
            compatibilidade, segurança e propósito real.
          </p>
        </div>

        <div className="mission-card">
          <h3>Visão</h3>

          <p>
            Ser a principal plataforma de relacionamento de alto padrão no
            Brasil, reconhecida por qualidade, segurança e experiências reais.
          </p>
        </div>

        <div className="mission-card">
          <h3>Valores</h3>

          <p>
            Discrição, segurança, autenticidade, respeito, privacidade e
            inovação em relacionamentos digitais.
          </p>
        </div>
      </section>

      <section className="v2-section">
        <ContactUs />
      </section>

      <section className="v2-section v2-center">
        <h2>Pronto para conhecer novas conexões?</h2>

        <p>
          Faça parte de uma comunidade de relacionamento de alto padrão, criada
          para pessoas que buscam conexões reais, seguras e com propósito.
        </p>

        <Link to="/cadastro">
          <button className="btn-primary">Solicitar Acesso Exclusivo</button>
        </Link>
      </section>
    </div>
  );
};

export default AboutUsScreen;
